export const archelFilterMaps: Record<string, string> = {
  dtaqua: 'deltatop aqua',
  dtair: 'deltatop air',
  'diameter<0.25': 'Fine sand (0.250)',
  'diameter<0.125': 'Very fine sand (0.125)',
};
